export default "<qrcode [qrdata]=\"qrCodeData.qrData\" [size]=\"qrCodeData.qrCodeSize\" [level]=\"'M'\">\n</qrcode>\n"